// +----------------------------------------------------------------------
// | 「想想」根组件
// +----------------------------------------------------------------------
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './lib/userStore';
import AppRoutes from './router';
import { ToastHost } from './components/Toast';

export default function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <ToastHost />
    </UserProvider>
  );
}
